import { Injectable } from '@angular/core';
import { SUPPORTED_LANGUAGES } from '@core/settings/language.settings';
import { ROOT_SCOPE_VARIABLES } from '@core/settings/root-scope.settings';
import { BehaviorSubject } from 'rxjs';
import { RootScopeService } from './upgraded-providers/wrappers/root-scope.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  _rootScopeChanges: any = {};
  private _language: string | undefined= SUPPORTED_LANGUAGES.en;

  language$ = new BehaviorSubject<string | undefined>(this._language);
  
  constructor(private _rootScopeService: RootScopeService) { 
    this._rootScopeService.detectScopeChanges(ROOT_SCOPE_VARIABLES.LANGUAGE.SELECTED_LANGUAGE_SET);
    //subscribe to rootScopeSubject to detect desired changes
    this._rootScopeService.rootScopeObservable
    .subscribe(() => {
      this._rootScopeChanges = this._rootScopeService.getRootScope();
      if (this._rootScopeChanges?.app?.language) {
        this.onSetLanguage(this._rootScopeChanges?.app?.language);
      }
    });
  }

  onSetLanguage(selectedLanguage: string){
    const supportedLanguage = SUPPORTED_LANGUAGES[selectedLanguage];
    if (supportedLanguage) {
      this._language = supportedLanguage;
      this.language$.next(supportedLanguage);
    }
  }
}
